
// @ts-nocheck
import locale__var_www_projects_nuxt_hillceramic_no_releases_20261105070052Z_locales_nb_NO_json from "../locales/nb_NO.json";


export const localeCodes =  [
  "no"
]

export const localeLoaders = {
  "no": [{ key: "../locales/nb_NO.json", load: () => Promise.resolve(locale__var_www_projects_nuxt_hillceramic_no_releases_20261105070052Z_locales_nb_NO_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "no",
      "language": "nb-NO",
      "files": [
        "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/locales/nb_NO.json"
      ]
    }
  ],
  "defaultLocale": "no",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": "locales",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "config",
  "pages": {
    "collections/index": {
      "sv": "/kollektioner",
      "da": "/samlinger",
      "no": "/kolleksjoner",
      "nb": "/kolleksjoner"
    }
  },
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "no",
    "language": "nb-NO",
    "files": [
      {
        "path": "/var/www/projects/nuxt.hillceramic.no/releases/20261105070052Z/locales/nb_NO.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
